<template>
    <pendo-router-link
        v-pendo-tooltip="{
            classes: 'side-nav-tooltip',
            content: tooltipContent,
            placement: 'right',
            arrow: true,
        }"
        pendo-analytics="upgrade-nav-item"
        class="upgrade-nav-item"
        :aria-label="label"
        :to="upgradeRoute"
        @click="handleUpgradeClick"
        @keyup.enter="handleUpgradeClick">
        <pendo-button class="upgrade-button">
            <svg
                class="filled-icon"
                fill="none"
                height="24"
                viewBox="0 0 24 24"
                width="24"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 19.9998C16.4183 19.9998 20 16.4182 20 11.9999C20 7.58169 16.4183 4 12 4C7.5818 4 4.00011 7.58169 4.00011 11.9999C4.00011 16.4182 7.5818 19.9998 12 19.9998Z"
                    stroke="var(--palette-gray-0)"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.75" />
                <path
                    d="M15.2001 11.9998L12.0001 8.79987L8.80012 11.9998"
                    stroke="var(--palette-gray-0)"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.75" />
                <path
                    d="M12 15.1998V8.79987"
                    stroke="var(--palette-gray-0)"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.75" />
            </svg>
            <div
                v-if="expanded"
                class="label-text">
                {{ label }}
            </div>
        </pendo-button>
    </pendo-router-link>
</template>

<script>
import PendoRouterLink from '@/vue-router/pendo-router-link.vue';
import { PendoButton, PendoTooltip } from '@pendo/components';

export default {
    name: 'Upgrade',
    compatConfig: {
        INSTANCE_LISTENERS: false,
    },
    components: {
        PendoRouterLink,
        PendoButton,
    },
    directives: {
        PendoTooltip,
    },
    props: {
        subscriptionPackageTiers: {
            type: Object,
            required: true,
        },
        showStarterUpgradePage: {
            type: Boolean,
            default: false,
        },
        isFreeAndNotIndia: {
            type: Boolean,
            default: false,
        },
        expanded: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['toggle'],
    computed: {
        isAStarterPackage () {
            return this.subscriptionPackageTiers.isStarterPackage || this.subscriptionPackageTiers.isStarter2024Package;
        },
        upgradeRoute () {
            if (this.isFreeAndNotIndia) {
                return null;
            }

            if (this.isAStarterPackage) {
                if (!this.showStarterUpgradePage) {
                    return null;
                }

                return { name: 'UpgradeNow' };
            }

            if (this.subscriptionPackageTiers.purchasableSelfServicePlan) {
                return { name: 'BuyNow' };
            }

            return null;
        },
        tooltipContent () {
            if (this.expanded) return '';

            return this.label;
        },
        label () {
            return this.$t('sideNav.Upgrade');
        },
    },
    methods: {
        handleUpgradeClick () {
            if (!this.upgradeRoute) {
                window.open('https://www.pendo.io/?q_showExperience=experience-1733339901350', '_blank');
            }
            this.$emit('toggle');
        },
    },
};
</script>

<style lang="less" scoped>
@import '@/side-nav/nav.style.less';

.upgrade-nav-item {
    width: 100%;
    min-width: 36px;
    display: flex;
    justify-content: center;
}

:deep(.upgrade-button) {
    min-width: 36px;
    border-radius: 5px;

    &:focus-visible {
        outline: 2px solid var(--palette-gray-90);
        outline-offset: -2px;
    }

    & > span {
        display: flex;
        align-items: center;
    }

    .label-text {
        margin-left: 10px;
    }
}
</style>
